"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ellipses = exports.calculateUTRs2 = exports.calculateUTRs = exports.revlist = exports.dedupe = exports.stitch = void 0;
function stitch(subfeats, sequence) {
  return subfeats.map(function (sub) {
    return sequence.slice(sub.start, sub.end);
  }).join('');
}
exports.stitch = stitch;
// filter items if they have the same "ID" or location
function getItemId(feat) {
  return "".concat(feat.start, "-").concat(feat.end);
}
// filters if successive elements share same start/end
function dedupe(list) {
  return list.filter(function (item, pos, ary) {
    return !pos || getItemId(item) !== getItemId(ary[pos - 1]);
  });
}
exports.dedupe = dedupe;
function revlist(list, seqlen) {
  return list.map(function (sub) {
    return _objectSpread({}, sub, {
      start: seqlen - sub.end,
      end: seqlen - sub.start
    });
  }).sort(function (a, b) {
    return a.start - b.start;
  });
}
exports.revlist = revlist;
// calculates UTRs using impliedUTRs logic
function calculateUTRs(cds, exons) {
  var firstCds = cds[0];
  var lastCds = cds[cds.length - 1];
  var firstCdsIdx = exons.findIndex(function (exon) {
    return exon.end >= firstCds.start && exon.start <= firstCds.start;
  });
  var lastCdsIdx = exons.findIndex(function (exon) {
    return exon.end >= lastCds.end && exon.start <= lastCds.end;
  });
  var lastCdsExon = exons[lastCdsIdx];
  var firstCdsExon = exons[firstCdsIdx];
  var fiveUTRs = [].concat(_toConsumableArray(exons.slice(0, firstCdsIdx)), [{
    start: firstCdsExon.start,
    end: firstCds.start
  }]).map(function (elt) {
    return _objectSpread({}, elt, {
      type: 'five_prime_UTR'
    });
  });
  var threeUTRs = [{
    start: lastCds.end,
    end: lastCdsExon.end
  }].concat(_toConsumableArray(exons.slice(lastCdsIdx + 1))).map(function (elt) {
    return _objectSpread({}, elt, {
      type: 'three_prime_UTR'
    });
  });
  return [].concat(_toConsumableArray(fiveUTRs), _toConsumableArray(threeUTRs));
}
exports.calculateUTRs = calculateUTRs;
// calculates UTRs using impliedUTRs logic, but there are no exon subfeatures
function calculateUTRs2(cds, parentFeat) {
  var firstCds = cds[0];
  var lastCds = cds[cds.length - 1];
  var fiveUTRs = [{
    start: parentFeat.start,
    end: firstCds.start
  }].map(function (elt) {
    return _objectSpread({}, elt, {
      type: 'five_prime_UTR'
    });
  });
  var threeUTRs = [{
    start: lastCds.end,
    end: parentFeat.end
  }].map(function (elt) {
    return _objectSpread({}, elt, {
      type: 'three_prime_UTR'
    });
  });
  return [].concat(_toConsumableArray(fiveUTRs), _toConsumableArray(threeUTRs));
}
exports.calculateUTRs2 = calculateUTRs2;
function ellipses(slug) {
  return slug.length > 20 ? "".concat(slug.slice(0, 20), "...") : slug;
}
exports.ellipses = ellipses;